<template>
	<div>
		<h2 class="title is-4 has-text-centered">Filter by</h2>

		<div class="buttons is-centered">
			<DropdownFilter
				v-for="taxonomy in taxonomies"
				:key="taxonomy"
				:taxonomy="taxonomy"
			/>
		</div>
	</div>
</template>

<script>

import DropdownFilter from './Dropdown.vue';

export default {
	props: {
		/* List of taxonomies to display dropdowns for */
		taxonomies: {
			type: Array,
			required: true,
		},
	},

	components: {
		DropdownFilter,
	},
};

</script>
